import { useTranslation } from 'react-i18next';

/** Shows a trace ID (first 8 hex chars); click copies the full ID for lookup in the tracing backend. */
export function TraceChip({ traceId }: { traceId?: string | null }) {
  const { t } = useTranslation();
  if (!traceId) return null;
  return (
    <button
      type="button"
      className="trace-chip"
      title={`${t('inbox.trace')}: ${traceId}`}
      data-trace-id={traceId}
      onClick={() => void navigator.clipboard?.writeText(traceId).catch(() => undefined)}
      style={{ font: 'inherit', fontFamily: 'var(--font-mono)', fontSize: '0.7rem' }}
    >
      {traceId.slice(0, 8)}
    </button>
  );
}
